import React, { useState } from 'react';
import { ref, push, set, serverTimestamp } from 'firebase/database';
import { database } from '../firebase';
import './HomeContactSurvey.css';

const TOPICS = [
  { value: '', label: 'Konu seçiniz' },
  { value: 'genel', label: 'Genel soru' },
  { value: 'uyelik', label: 'Üyelik' },
  { value: 'standartlar', label: 'Mesleki standartlar' },
  { value: 'sanayi', label: 'Sanayi iş birlikleri' },
  { value: 'egitim', label: 'Eğitim / seminer' },
  { value: 'diger', label: 'Diğer' },
];

const HEARD_FROM = [
  { value: '', label: 'Seçiniz (isteğe bağlı)' },
  { value: 'arama', label: 'Arama motoru (Google vb.)' },
  { value: 'sosyal', label: 'Sosyal medya' },
  { value: 'tavsiye', label: 'Tavsiye / referans' },
  { value: 'etkinlik', label: 'Etkinlik / seminer' },
  { value: 'diger', label: 'Diğer' },
];

const HomeContactSurvey = () => {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    topic: '',
    message: '',
    heardFrom: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const update = (name, value) => setForm((prev) => ({ ...prev, [name]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.fullName?.trim() || !form.email?.trim() || !form.message?.trim()) {
      setError('Lütfen ad soyad, e-posta ve mesaj alanlarını doldurunuz.');
      return;
    }
    setSubmitting(true);
    try {
      const surveyRef = ref(database, 'contactSurvey');
      const newRef = push(surveyRef);
      await set(newRef, {
        ...form,
        createdAt: serverTimestamp(),
      });
      setSuccess(true);
      setForm({ fullName: '', email: '', topic: '', message: '', heardFrom: '' });
    } catch (err) {
      setError(err.message || 'Gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="home-contact-survey" id="iletisim-anketi">
      <div className="home-contact-survey-inner">
        <div className="home-contact-survey-header">
          <span className="home-contact-survey-label">Görüş ve önerileriniz</span>
          <h2 className="home-contact-survey-title">İletişim Anketi</h2>
          <p className="home-contact-survey-desc">
            Sorularınızı iletebilir veya TKMB hakkındaki görüşlerinizi paylaşabilirsiniz. Mesajınız en kısa sürede değerlendirilecektir.
          </p>
        </div>

        {success ? (
          <div className="home-contact-survey-success">
            <p>Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapılacaktır.</p>
          </div>
        ) : (
          <form className="home-contact-survey-form" onSubmit={handleSubmit}>
            {error && <div className="home-contact-survey-error">{error}</div>}
            <div className="home-contact-survey-row">
              <label className="home-contact-survey-field">
                <span>Ad Soyad <em>*</em></span>
                <input
                  type="text"
                  value={form.fullName}
                  onChange={(e) => update('fullName', e.target.value)}
                  placeholder="Adınız ve soyadınız"
                  required
                />
              </label>
              <label className="home-contact-survey-field">
                <span>E-posta <em>*</em></span>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => update('email', e.target.value)}
                  placeholder="ornek@email.com"
                  required
                />
              </label>
            </div>
            <label className="home-contact-survey-field">
              <span>Konu</span>
              <select
                value={form.topic}
                onChange={(e) => update('topic', e.target.value)}
              >
                {TOPICS.map((opt) => (
                  <option key={opt.value || 'empty'} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </label>
            <label className="home-contact-survey-field">
              <span>Mesajınız <em>*</em></span>
              <textarea
                value={form.message}
                onChange={(e) => update('message', e.target.value)}
                placeholder="Mesajınızı yazınız..."
                rows={4}
                required
              />
            </label>
            <label className="home-contact-survey-field">
              <span>TKMB'yi nereden duydunuz? (isteğe bağlı)</span>
              <select
                value={form.heardFrom}
                onChange={(e) => update('heardFrom', e.target.value)}
              >
                {HEARD_FROM.map((opt) => (
                  <option key={opt.value || 'empty'} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </label>
            <div className="home-contact-survey-actions">
              <button type="submit" className="home-contact-survey-submit" disabled={submitting}>
                {submitting ? 'Gönderiliyor...' : 'Gönder'}
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
};

export default HomeContactSurvey;
